import { render, staticRenderFns } from "./MobileOnly.vue?vue&type=template&id=4f83739d&scoped=true&"
var script = {}
import style0 from "./MobileOnly.vue?vue&type=style&index=0&id=4f83739d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f83739d",
  null
  
)

export default component.exports